import {
    GIFTCARD_HOLD_LOADNG, GIFTCARD_HOLD_SUCCESS, GIFTCARD_HOLD_ERROR, GIFTCARD_HOLD_RESET,
    GIFTCARD_HOLD_DELETE_LOADNG,GIFTCARD_HOLD_RECALCULATE_LOADNG
} from "../actions/actionGiftCardHold";

const initialState = {
    GiftCardHold: {},
    GiftCardHoldLoading: false,
    GiftCardHoldError: ''
};

function reducerGiftCardHold(state = initialState, action) {
    switch (action.type) {
        case(GIFTCARD_HOLD_LOADNG):
        case (GIFTCARD_HOLD_DELETE_LOADNG):
        case (GIFTCARD_HOLD_RECALCULATE_LOADNG): {
            return {
                ...state,
                GiftCardHoldLoading: true,
                GiftCardHold: {},
                GiftCardHoldError: ''
            };
        }
        case GIFTCARD_HOLD_SUCCESS: {
            return {
                ...state,
                GiftCardHoldLoading: false,
                GiftCardHold: action.payload[0],
                GiftCardHoldError: ''
            };
        }
        case GIFTCARD_HOLD_ERROR: {

            let error = "";
            if (action.error.Errors) {
                error = action.error.Errors[0].ErrorMessage
            }
            else
                error = action.error.message;

            return {
                ...state,
                GiftCardHoldLoading: false,
                GiftCardHold: {},
                GiftCardHoldError: error
            }
        }
        case GIFTCARD_HOLD_RESET: {
            return {
                ...state,
                GiftCardHoldLoading: false,
                GiftCardHold: {},
                GiftCardHoldError: ''
            };
        }
        default: {
            return state;
        }
    }
}

export default reducerGiftCardHold;